(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!window.__amEmailSignupPageToastInit) {
    window.__amEmailSignupPageToastInit = true;

    const maybeShowPageToast = () => {
      const params = new URLSearchParams(window.location.search);
      const isNewsletterSubmitResult =
        params.get('customer_posted') === 'true' ||
        params.get('contact_posted') === 'true' ||
        params.get('form_type') === 'customer' ||
        window.location.hash === '#contact_form';

      if (!isNewsletterSubmitResult) return;

      const successMessage = document.querySelector('.email-signup-block .email-signup__message--success');
      if (!successMessage) return;

      const toastText = successMessage.textContent ? successMessage.textContent.trim() : '';
      if (!toastText) return;

      if (document.querySelector('[data-email-signup-page-toast]')) return;

      successMessage.style.display = 'none';

      const toast = document.createElement('div');
      toast.className = 'email-signup-page-toast';
      toast.setAttribute('data-email-signup-page-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      const icon = document.createElement('span');
      icon.className = 'email-signup-page-toast__icon';
      icon.textContent = '✓';

      const text = document.createElement('p');
      text.className = 'email-signup-page-toast__text';
      text.textContent = toastText;

      toast.appendChild(icon);
      toast.appendChild(text);
      document.body.appendChild(toast);

      requestAnimationFrame(() => {
        toast.classList.add('is-visible');
      });

      const hideToast = () => {
        if (!toast.isConnected) return;
        toast.classList.add('is-hidden');
        toast.classList.remove('is-visible');
        window.setTimeout(() => {
          if (toast.isConnected) toast.remove();
        }, 300);
      };

      window.setTimeout(hideToast, 3200);
      toast.addEventListener('click', hideToast);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', maybeShowPageToast, { once: true });
    } else {
      maybeShowPageToast();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
